import moment from 'moment-timezone';
import { allTimezones } from 'react-timezone-select';

const DEFAULT_LOCALE = "en-US";

export const timezoneOptions = Object.keys(allTimezones).reduce((acc, tz) => {
    acc[tz] = tz;
    return acc;
}, {});

const getResolvedTimezone = (timezone) => {
    if (timezone) return timezone;
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const getDate = (value) => {
    if (!value) return null;

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    // Backend sends UTC timestamps like "YYYY-MM-DD HH:mm:ss" with no "T"
    // separator or timezone marker, which JS parses as local time instead
    // of UTC. Normalize to an explicit UTC ISO string before parsing.
    let normalized = value;
    if (typeof value === "string" && value.includes(" ") && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(value)) {
        normalized = `${value.trim().replace(" ", "T")}Z`;
    }

    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
};

const formatWithOptions = (value, timezone, options) => {
    const date = getDate(value);

    if (!date) return "-";

    try {
        return new Intl.DateTimeFormat(DEFAULT_LOCALE, {
            timeZone: getResolvedTimezone(timezone),
            ...options,
        }).format(date);
    } catch {
        return "-";
    }
};

export const formatUtcDateTime = (value, timezone) => formatWithOptions(value, timezone, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
});

export const formatUtcDate = (value, timezone) => formatWithOptions(value, timezone, {
    year: "numeric",
    month: "short",
    day: "numeric",
});

const REF_DATE = "2000-01-03"; // a fixed Monday, used only to anchor time math

export const convertTimeToUtc = (timeStr, timezone) => {
    if (!timeStr || !timezone) return timeStr;
    return moment.tz(`${REF_DATE} ${timeStr}`, "YYYY-MM-DD HH:mm:ss", timezone)
        .utc()
        .format("HH:mm:ss");
};

export const convertUtcTimeToTimezone = (timeStr, timezone) => {
    if (!timeStr || !timezone) return timeStr;
    return moment.utc(`${REF_DATE} ${timeStr}`, "YYYY-MM-DD HH:mm:ss")
        .tz(timezone)
        .format("HH:mm:ss");
};
